/* eslint-disable @typescript-eslint/naming-convention */
import { ContactFields } from '../../components/contact-info/contact-info.interface';
import { ReplaySubject, Observable } from 'rxjs';

export interface PickerOptions {
    position?: string;
    mode?: string;
    hasBackDrop?: boolean;
    allowQuickCreate: boolean;
    showQuickCreateOnly?: boolean;
    showCustomDataOnly?: boolean;
    prefillValues?: any; //It's only applicable when allowQuickCreate is true and we want prefill the form values
    quickCreateOptions?: PickerQuickCreateOptions; //It's only applicable when allowQuickCreate is true
    selectOption: PickerSelectOptions;
    customParams?: any; //Add more params to data picker for filter the required data
    showListCount?: boolean;
    filters?: PickerFilterOptions;
    selectionDisableBasedOn?: PickerSelectDisableOptions; //when we enable disable option, we should add elementId
    elementID?: string;
    tooltipText?: string;
    allowToRemoveSelectedItem?: boolean; //Applicable only for single item selection (PickerSelectOptions.select)
    enableFooterCheckbox?: PickerFooterCheckbox; //Applicable only for single item selection (PickerSelectOptions.select)
    enableDataTab?: boolean; //Applicable only for custom data related tab
    maxSelectionLimit?: number; //Applicable only for multiselect option
    dataConfig?: any; //Applicable to pass custom data
    disableSelected?: boolean;
    data?: any[];
    header?: {
        displayKey: string;
        displayName: string;
    };
    footer?: {
        displayKey: string;
        displayName: string;
    };
    showNotification?: boolean;
    fromModule?: string;
    showPreSelectedValue?: boolean;
}

export enum PickerSelectOptions {
    select = 'select',
    multiSelect = 'multiSelect',
    readOnly = 'readOnly'
}

export enum PickerSelectDisableOptions {
    GEOLOCATION = 'GEOLOCATION',
    JOB = 'JOB',
    ASSET = 'ASSET',
    PROPERTY = 'PROPERTY',
    CUSTOMER = 'CUSTOMER',
    RECURRENCE_JOB_MASTER = 'RECURRENCE_JOB_MASTER',
}

export interface PickerQuickCreateOptions {
    disableOrganization?: boolean;
    hideOrganization?: boolean;
}

export interface PickerFilterOptions {
    enableCategory?: boolean;
    dateRange?: {
        enabled: boolean;
        hideCloseIcon?: boolean;
    };
    getPropertyWithoutOrg?: boolean;
    getCustomerWithoutOrg?: boolean;
    enableAssignmentStatus?: boolean;
    enableAssetStatus?: boolean;
    enableAssignEmployee?: boolean;
    showRecurrenceMaster?: boolean;
    enableShowAllJobs?: boolean;
    filterByCustomer?: {
        enabled: boolean;
        selectedValue?: any;
        valueDisabled?: boolean;
    };
    filterByOrganization?: {
        enabled: boolean;
        selectedValue?: any;
        valueDisabled?: boolean;
        getDataWhenCleared?: boolean;
        filterKey?: string;
    };
    filterByProperty?: {
        enabled: boolean;
        selectedValue?: any;
        valueDisabled?: boolean;
    };
}

export interface PickerFooterCheckbox {
    enabled: boolean; //Set true to enable the check box with label
    labelKey: string;
    labelName: string;
    defaultValue: boolean; //Set default value to checkbox either checked or unchecked
}

export interface CreateFormField {
    labelName: string;
    labelDisplayKey: string;
    fieldId: string;
    fieldType: string;
    inputType?: string;
    formControlName?: string;
    placeHolder?: string;
    placeHolderDisplayKey?: string;
    isMandatory?: boolean;
    valueKey?: string;
    observable?: Observable<any>;
    oberservableKey?: string;
    oberservableValue?: string;
    allowLoading?: boolean;
    allowLazyLoading?: boolean;
    valueSubject?: ReplaySubject<string | null>;
    cssClass?: string;
    validationText?: string;
    validationTextKey?: string;
    emailValidationText?: string;
    emailValidationTextKey?: string;
    showIf?: boolean;
    data?: any[];
}

export interface CreateForm {
    headerName: string;
    headerDisplayKey: string;
    canShow: boolean;
    isMatCheck?: boolean;
    formControlName?: string;
    formGroupName?: string;
    matCheckLabel?: string;
    headerType?: string;
    formFields: CreateFormField[];
    contactFields?: ContactFields;
}
